import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconLock = (props: PropsType) => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M26.5556 55.2778C25.8056 55.2778 25.1552 55.0024 24.6043 54.4516C24.0535 53.9005 23.7781 53.2499 23.7781 52.4999V28.0557C23.7781 27.3057 24.0535 26.6552 24.6043 26.1041C25.1552 25.5532 25.8056 25.2778 26.5556 25.2778H54.7781C55.5281 25.2778 56.1785 25.5532 56.7293 26.1041C57.2802 26.6552 57.5556 27.3057 57.5556 28.0557V52.4999C57.5556 53.2499 57.2802 53.9005 56.7293 54.4516C56.1785 55.0024 55.5281 55.2778 54.7781 55.2778H26.5556ZM26.5556 52.4999H54.7781V28.0557H26.5556V52.4999ZM29.0002 48.6112H37.3335V45.2778H29.0002V48.6112ZM44.9168 45.2778L53.1668 37.0278L50.7918 34.6528L44.9168 40.5695L42.5418 38.1945L40.2085 40.5695L44.9168 45.2778ZM29.0002 41.9445H37.3335V38.6112H29.0002V41.9445ZM29.0002 35.2778H37.3335V31.9445H29.0002V35.2778Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconLock;
